/**
 * returns true if two given arrays are the same.
 * @template T
 * @param {T[]} array1
 * @param {T[]} array2
 * @returns {boolean}
 *
 * @example
 * areArraysEqual([1,2,3],[1,2,3])
 * // returns true
 *
 * @example
 * areArraysEqual([1,2,3],[2,3])
 * // returns false
 */
export var areArraysEqual = function (array1, array2) { return Array.isArray(array1)
    && Array.isArray(array2)
    && array1.length === array2.length
    && array1.every(function (val, index) { return val === array2[index]; }); };
//# sourceMappingURL=areArraysEqual.js.map